/* eslint-disable import/prefer-default-export */

export const MENUS = {
  personnel: 'can-view-personnel-page',
  regularContractorF30: 'can-view-regular-contractor-f30-page',
  store: 'can-view-area-section-tienda-page',
  sectionVehicles: 'can-view-area-section-vehicles-page',
  liveAccess: 'can-view-area-section-live-accesses',
};
